import React, { useMemo } from 'react';

import { useAIAssistantStatus } from 'src/features/assistant/useAIAssistantStatus';
import { ChannelContent } from 'src/features/channel/channel-content/ChannelContent';

interface ChatChannelContentWrapperProps {
  ChannelToolbar?: React.ReactNode;
  MessageListOverride?: React.ReactNode;
  autoFocus?: boolean;
  defaultInputValue?: string;
  onChange?: (text: string) => void;
  onSubmit?: () => void;
  showMessageInput?: boolean;
  placeholderText?: string;
  typingStatus?: {
    typingUsers: Array<{
      user?: {
        id?: string;
        name?: string;
      };
    }>;
  } | null;
  isInternalChat?: boolean;
  setAIAssistantStatus?: (
    channelId: string,
    status: string,
    metadata?: { tool?: string; query?: string },
  ) => void;
  clearAIAssistantStatus?: () => void;
  allowScroll?: boolean;
}

/**
 * Wrapper component that must be rendered inside a Channel provider context.
 * It retrieves the AI assistant status and passes it to ChannelContent.
 */
export const ChatChannelContentWrapper = (
  props: ChatChannelContentWrapperProps,
) => {
  const { status: aiAssistantStatus, cancelStream } = useAIAssistantStatus();

  const memoizedProps = useMemo(() => props, [props]);
  const memoizedAssistantStatus = useMemo(
    () => aiAssistantStatus,
    [aiAssistantStatus],
  );

  return (
    <ChannelContent
      {...memoizedProps}
      aiAssistantStatus={memoizedAssistantStatus}
      cancelAIStream={cancelStream}
    />
  );
};
